// extracted by mini-css-extract-plugin
export var backButton = "_1i-1";
export var content = "_1i-d";
export var continueButton = "_1i-7";
export var continueHint = "_1i-8";
export var continueRow = "_1i-6";
export var leftInner = "_1i-0";
export var sidebarContent = "_1i-5";
export var skipButton = "_1i-c";
export var spacer = "_1i-2";
export var spin = "_1i-a";
export var spinner = "_1i-9";
export var spinnerOverlay = "_1i-b";
export var subtitle = "_1i-4";
export var title = "_1i-3";